// extracted by mini-css-extract-plugin
export default {"root":"PaymentMethodTable_root__jSZQP"};